<!-- Skip Link component for keyboard navigation -->
<template>
  <div class="skip-links">
    <a 
      class="skip-link" 
      href="#main-content"
      @click="focusMainContent"
    >
      Skip to main content
    </a>
    <a 
      class="skip-link" 
      href="#navigation"
    >
      Skip to navigation
    </a>
  </div>
</template>

<script>
export default {
  name: 'SkipLinks',
  methods: {
    focusMainContent() {
      this.$nextTick(() => {
        const mainContent = document.getElementById('main-content');
        if (mainContent) {
          mainContent.focus();
          mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }
}
</script>

<style scoped>
.skip-links {
  position: relative;
}

.skip-link {
  position: absolute;
  top: -1000px;
  left: -1000px;
  height: 1px;
  width: 1px;
  text-align: left;
  overflow: hidden;
  background: var(--color-accent-discord);
  color: var(--color-text-primary);
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--border-radius-sm);
  text-decoration: none;
  font-weight: 600;
  z-index: var(--z-index-tooltip, 600);
  transition: all var(--transition-fast);
}

.skip-link:active,
.skip-link:focus {
  position: fixed;
  top: 10px;
  left: 10px;
  width: auto;
  height: auto;
  overflow: visible;
  box-shadow: var(--shadow-lg);
}

.skip-link:focus-visible {
  outline: 3px solid var(--color-text-primary);
  outline-offset: 2px;
}
</style>